import basicResourceApi from 'providers/basicResourceProvider'

export const getGrades = async () => {
  const data = await basicResourceApi.get('/grades?per_page=-1')
  return data.map(({ id, name, ...grade }) => ({ value: id, label: name, ...grade }))
}
